import * as React from 'react'
import { ProgressBarImage } from './ProgressBar.styles'

interface IProps {
  progress: 70 | 90
}

const progressBar70ImageUrl = `https://ucarecdn.com/0e4e96c3-312c-4e4a-bc11-360b901f6583/progressbar70.png`
const progressBar90ImageUrl = `https://ucarecdn.com/e53c8e9d-fe26-43c8-8f02-e3c9c8e61ff8/progressbar90.png`

export default function ProgressBar(props: IProps) {
  const { progress } = props

  return <ProgressBarImage src={progress === 70 ? progressBar70ImageUrl : progressBar90ImageUrl} />
}
